import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classnames from 'classnames'

import Logo from './Logo'

import { activateHeaderToggling } from '../../reducers/header'

function HeaderDesktop () {
  return (
    <div className='header--desktop items-center'>
      <Logo extraClass='mr3' />
    </div>
  )
}

function HeaderMobile () {
  // const [submenuOpen, setSubmenuOpen] = useState('')
  return (
    <div className='header--mobile flex-column'>
      <div className='header--mobile__logo-menu flex justify-center relative items-center pl1'>
        <Logo />
      </div>
    </div>
  )
}

function Header () {
  return (
    <header className={classnames('header')}>
      <HeaderDesktop />
      <HeaderMobile />
    </header>
  )
}

Header.propTypes = {
  activePathname: PropTypes.string.isRequired
}

const mapStateToProps = ({ location, header: { isHeaderTogglingActive } }) => {
  return {
    activePathname: location.pathname,
    isHeaderTogglingActive
  }
}

export default connect(
  mapStateToProps,
  { activateHeaderToggling }
)(Header)
